import { z } from 'zod';

import { AddSupplierRoleBodySchema } from './add-supplier-role.schemas.js';

export const CompleteSupplierRegistrationBodySchema = AddSupplierRoleBodySchema;

export type CompleteSupplierRegistrationBody = z.infer<
  typeof CompleteSupplierRegistrationBodySchema
>;

export const CompleteSupplierRegistrationResponseSchema = z.object({
  partyId: z.uuid(),
  supplierRoleId: z.uuid(),
});

export type CompleteSupplierRegistrationResponse = z.infer<
  typeof CompleteSupplierRegistrationResponseSchema
>;
